import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { RouterProvider } from 'react-router'
import './app/theme.css'
import './ui/ui.css'
import { log, reason } from './app/log.js'
import { Providers } from './app/providers.js'
import { router } from './app/router.js'
import { i18next, initI18n } from './i18n/index.js'
import { applyReviewQuery } from './parent/review.js'

const logger = log('boot')

async function start() {
  await initI18n('tr')
  // Review mode link for professors and testers: `?inceleme=<code>` on any URL, applied before
  // the store boots so the first fold already has the unlock. WP-F owns the hook; it is imported
  // from its own module so the parent screens stay in their lazy chunk (ARCHITECTURE §9).
  if (await applyReviewQuery()) logger.info('review mode applied from the link')
  const container = document.getElementById('root')
  if (!container) throw new Error('#root is missing from index.html')

  createRoot(container).render(
    <StrictMode>
      <I18nextProvider i18n={i18next}>
        <Providers>
          <RouterProvider router={router} />
        </Providers>
      </I18nextProvider>
    </StrictMode>,
  )
}

start().catch((error) => {
  logger.error('the app could not start', reason(error))
  const container = document.getElementById('root')
  if (container) {
    container.textContent = 'Bir şey ters gitti. Sayfayı yenileyin.'
  }
})
